module.exports = __webpack_public_path__ + "static/media/lesson_available_ic.837421b5.svg";